import { CHAT_FUNCTIONS } from '../../../config/chatFunctionNames';

/**
 * Check if a message is a Google Calendar events response.
 */
export function isCalendarEventMessage(message) {
  return message?.function_name === CHAT_FUNCTIONS.CALENDAR_EVENTS;
}

/**
 * Extract calendar event data from raw_output.
 * Returns { events, metadata, freeTimeSummary, limitNotice, resumePrompt } or null.
 *
 * - freeTimeSummary: Optional free-time hint shown below cards (e.g. "Before 9am ... you are free")
 * - limitNotice: Optional last line when the list was cut (e.g. "Showing 30 of 46 events this month.")
 * - resumePrompt: Optional prompt shown when user has a paused booking flow
 */
export function getCalendarEventData(message) {
  if (!isCalendarEventMessage(message)) return null;

  const rawOutput = message.raw_output;
  if (!rawOutput) return null;

  const events = rawOutput.events;
  if (!Array.isArray(events) || events.length === 0) return null;

  return {
    events,
    metadata: rawOutput.metadata || {},
    freeTimeSummary: rawOutput.free_time_summary || '',
    limitNotice: rawOutput.limit_notice || '',
    resumePrompt: rawOutput.resume_prompt || '',
  };
}

/**
 * Extract header text before the numbered event list.
 * e.g. "Your current location: Kiln Boulder" from full content.
 * Uses same regex pattern as organization events.
 */
export function getCalendarEventHeader(content) {
  if (!content) return content;
  // Split at first numbered item (e.g. "1) " or "1. ")
  const parts = content.split(/\n\n\s*\d+[.)]\s/);
  return parts[0].trim();
}
